export default __webpack_public_path__ + "static/media/floppy_disk_icon.9b19841d.svg";